/** Токены оформления, доступные из JS: графики и инлайновые стили
 *  берут цвета отсюда, чтобы палитра совпадала с темой antd (theme.less). */
export const tokens = {
    ink: '#0F172A',
    muted: '#64748B',
    border: '#E2E8F0',
    surface: '#FFFFFF',
    bg: '#F1F5F9',
    primary: '#2563EB',
    primaryDark: '#1D4ED8',
    accent: '#0EA5A4',
    danger: '#E11D48',
    warning: '#F59E0B',
    radius: 14,
    shadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06)',
}

/** Палитра серий на графиках: различима и в цвете, и в оттенках серого. */
export const chartPalette = ['#2563EB', '#0EA5A4', '#F59E0B', '#E11D48', '#7C3AED', '#0891B2']

export const numberFormat = new Intl.NumberFormat('ru-RU')

/** Короткая запись для осей: 12 400 -> «12,4 тыс», 3 200 000 -> «3,2 млн». */
export const formatCompact = (value) => {
    if (value === null || value === undefined || isNaN(value)) return ''
    const abs = Math.abs(value)
    if (abs >= 1e6) return `${(value / 1e6).toFixed(abs >= 1e7 ? 0 : 1).replace('.', ',')} млн`
    if (abs >= 1e4) return `${(value / 1e3).toFixed(0)} тыс`
    if (abs >= 1e3) return `${(value / 1e3).toFixed(1).replace('.', ',')} тыс`
    return numberFormat.format(Math.round(value * 100) / 100)
}

/** Значение с единицей измерения — для подсказок на графиках. */
export const formatValue = (value, unit) => {
    if (value === null || value === undefined || isNaN(value)) return '—'
    const rounded = Math.abs(value) >= 100 ? Math.round(value) : Math.round(value * 10) / 10
    return `${numberFormat.format(rounded)}${unit ? ` ${unit}` : ''}`
}

/** Общие настройки осей и сетки, чтобы графики выглядели одинаково. */
export const axisProps = {
    tick: {fill: tokens.muted, fontSize: 11},
    tickLine: false,
    axisLine: {stroke: tokens.border},
    tickMargin: 8,
}

/** Ось значений: короткие подписи и запас сверху, чтобы линия не липла к краю. */
export const valueAxisProps = {
    ...axisProps,
    // ширина под самую длинную подпись («100 тыс»), иначе SVG её обрезает
    width: 76,
    tickFormatter: formatCompact,
}

/** Ось лет: подписи прореживаются, чтобы не наезжали друг на друга. */
export const yearAxisProps = {
    ...axisProps,
    minTickGap: 24,
    padding: {left: 4, right: 4},
}

export const gridProps = {
    stroke: tokens.border,
    strokeDasharray: '4 4',
    vertical: false,
}

